import { IAccount, LocationService, ILocation } from "../../../services/index";
import * as _ from "lodash";
interface IResolve {
    account: IAccount;
    locations: ILocation[];
}

class LocationsItemController {

    private resolve: IResolve;
    private account: IAccount;
    private location: ILocation;
    private close: any;

    constructor(
        private LocationService: LocationService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private SweetAlert: any
    ) {
        'ngInject';
    }


    public $onInit = () => {
        this.account = this.resolve.account;
        var locationId : string = this.$stateParams['locationId'];
        if (locationId != '') {
            this.location = _.find(this.resolve.locations, { 'id': locationId });
        } else {
            this.location = new ILocation();
        }
    }

    public submitLocation() {
        if (this.location.id === undefined) {
            this.location.accountId = this.account.id;
            this.LocationService.post(this.location).then((data) => {
                this.closeModal();
            });
            // this.locations.push(this.location);
        } else {
            this.LocationService.put(this.location.id, this.location).then((data) => {
                this.closeModal();
            });
        }
    }

    delete() {

        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u '+ this.location.name +' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.LocationService.delete(this.location.id).then((data) => {
                    this.closeModal();
                });
            } else {

            }
        });        
      
    }

    private closeModal() {
        this.$state.go('^', {tab: 3}, {reload: true});
    }
}

export const locationsItemComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: LocationsItemController,
    template: require('./locations.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/locations/locations.item.component.ts